// Notifications.jsx
import React from 'react'
import PropTypes from 'prop-types'

import styles from '../../../css/notifications.module.css'

const StatusSaveCheck = ({
  outcome,
  visible,
}) => {
  if (visible) {
    let colorValue
    let message

    switch (outcome) {
      case 'success':
        colorValue = styles.saveStatusCheckSuccess
        message = 'fa-check-circle'
        break

      case 'failure':
        colorValue = styles.saveStatusCheckError
        message = 'fa-times-circle'
        break

      default:
        colorValue = styles.saveStatusCheckWarning
        message = 'fa-times-circle'
        break
    }

    return (
      <i className={`fa ${message} fa-3x ${colorValue}`} />
    )
  }

  // not visible
  return ''
}

StatusSaveCheck.propTypes = {
  outcome: PropTypes.string,
  visible: PropTypes.bool,
}

export default StatusSaveCheck
